'use strict';

const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    isGroupMember: function() {
        return this.get('isMember') || this.get('isAdmin');
    },

    getMode: function() {
        return this.get('mode');
    },

    isModelEditable: function() {
        if(!this.isGroupMember()) {
            return false;
        }

        if(this.isSnapshotMode()) {
            return false;
        }

        return true;
    },

    isLocked: function() {
        return this._isLocked;
    },

    lock: function() {
        if(!this._isLocked) {
            this._isLocked = true;
            this.trigger('change:lock');
        }
    },

    unlock: function() {
        if(this._isLocked) {
            this._isLocked = false;
            this.trigger('change:lock');
        }
    },

    isSnapshotMode: function() {
        return this.getMode() == 'snapshot';
    },

    isMultiMode: function() {
        return this.getMode() == 'multi';
    },

    isRectSelectMode: function() {
        return this.getMode() == 'rectSelect';
    },

    isEditable: function() {
        if(this.isLocked()) {
            this.trigger('lock:edit');
            return false;
        }

        return this.isModelEditable();
    },

    isNodeDetailEditable: function() {
        return this.isModelEditable();
    },

    isLinkDetailEditable: function() {
        return this.isModelEditable();
    },

    isTagEditable: function() {
        return this.isModelEditable();
    },


    isCreatable: function() {
        if(this.isLocked()) {
            this.trigger('lock:edit');
            return false;
        }

        return this.isModelEditable();
    },

    isLinkCreatable: function() {
        if(this.isLocked()) {
            return false;
        }

        return this.isModelEditable();
    },

    isMovable: function() {
        if(this.isLocked()) {
            this.trigger('lock:edit');
            return false;
        }

        return this.isModelEditable();
    },

    isLinkVendable: function() {
        if(this.isLocked()) {
            return false;
        }

        return this.isModelEditable();
    },

    isMultiSelectable: function() {
        if(!this.isGroupMember()) {
            return false;
        }

        if(this.isSnapshotMode()) {
            return false;
        }

        if(this.isMultiMode()) {
            return true;
        }

        if(this.isRectSelectMode()) {
            return true;
        }

        return false;
    },

    isRectSelectable: function() {
        if(!this.isGroupMember()) {
            return false;
        }

        if(this.isSnapshotMode()) {
            return false;
        }

        // 矩形選択中の場合は二重にはできない
        if(this.isRectSelectMode()) {
            return false;
        }

        return true;
    },

    isCommentable: function() {
        return this.isGroupMember();
    }
});



// WEBPACK FOOTER //
// ./system/domain/service/auth.js